import { useSyncExternalStore } from 'react';

/** Phone width: where the app swaps popovers for sheets and points people to Work Orders. */
export const PHONE_WIDTH_QUERY = '(max-width: 760px)';
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** Whether a CSS media query matches now, re-rendering when it changes. False when rendered without a window. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia?.(query);
      list?.addEventListener?.('change', onChange);
      return () => list?.removeEventListener?.('change', onChange);
    },
    () => window.matchMedia?.(query).matches ?? false,
    () => false,
  );
}

/** Whether the person asked their system for less motion. */
export const useReducedMotion = () => useMediaQuery(REDUCED_MOTION_QUERY);

export const usePhoneWidth = () => useMediaQuery(PHONE_WIDTH_QUERY);
